import styled from 'styled-components';

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 85%;
`;

export const InfoLabel = styled.label`
  font-weight: 600;
  font-size: 0.9rem;
  color: #334155;
  margin: 0;
`;

export const InfoSpanDescription = styled.span`
  font-size: 0.75rem;
  color: #94a3b8;
  line-height: 1.3;
  margin-top: 2px;
`;
